import { Component } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface Tab {
    id: string;
    label: string;
    blocks: ContentBlock[];
}

export interface TabGroupBlock extends ContentBlock {
    tabs: Tab[];
}

@Component({
    template: `
        <mat-tab-group>
            <mat-tab *ngFor="let tab of block.tabs; trackBy: tabId" [label]="tab.label">
                <tyt-content-view [blocks]="tab.blocks"></tyt-content-view>
            </mat-tab>
        </mat-tab-group>
    `
})
export class ViewComponent extends ContentBlockViewComponent<TabGroupBlock> {
    tabId(tab: Tab) { return tab.id; }
}

@Component({
    template: `
        <mat-tab-group>
            <mat-tab *ngFor="let tab of block.tabs; trackBy: tabId" [label]="tab.label">
                <div class="controls">
                    <mat-form-field class="label" appearance="outline" floatLabel="always">
                        <mat-label>Label</mat-label>
                        <input type="text" matInput [(ngModel)]="tab.label" />
                    </mat-form-field>
                    <div class="spacer"></div>
                    <button mat-icon-button (click)="addAfter(tab)">
                        <mat-icon>add</mat-icon>
                    </button>
                    <button mat-icon-button (click)="remove(tab)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <tyt-content-editor [blocks]="tab.blocks"></tyt-content-editor>
            </mat-tab>
        </mat-tab-group>
    `,
    styles: [`
        .controls {
            display: flex;
            align-items: baseline;
        }
        tyt-content-editor {
            display: block;
            margin: 1em;

            mat-form-field.label {
                flex-grow: 1;
            }
        }
    `]
})
export class EditorComponent extends ContentBlockEditorComponent<TabGroupBlock> {
    tabId(tab: Tab) { return tab.id; }
    remove(tab: Tab) {
        let index = this.block.tabs.indexOf(tab);
        if (index >= 0)
            this.block.tabs.splice(index, 1);
    }

    addAfter(tab: Tab) {
        let index = this.block.tabs.indexOf(tab);
        if (index >= 0) {
            this.block.tabs.splice(index, 0, {
                id: crypto.randomUUID(),
                label: 'Tab',
                blocks: []
            });
        }
    }
}

export const TAB_GROUP_BLOCK_TYPE: ContentBlockType<TabGroupBlock> = {
    id: 'tab-group',
    label: 'Tab Group',
    icon: 'dashboard',
    template: {
        tabs: [
            {
                id: '701d3749-96e0-4219-84a8-b17c3ad694d8',
                label: '',
                blocks: []
            }
        ]
    },
    preview: {
        tabs: [
            {
                id: '701d3749-96e0-4219-84a8-b17c3ad694d8',
                label: 'Tab 1',
                blocks: []
            },
            {
                id: '701d3749-96e0-4219-84a8-b17c3ad694d8',
                label: 'Tab 2',
                blocks: []
            }
        ]
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
